import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiLanguageService } from 'ng-jhipster';

import { Account, Principal } from '../shared';
import {Router} from '@angular/router';

@Component({
    selector: 'jhi-home',
    templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
    account: Account;
    modalRef: NgbModalRef;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private principal: Principal,
        private router: Router
    ) {
        this.jhiLanguageService.setLocations(['home']);
    }

    ngOnInit() {
        this.principal.rootUrl().then(rootUrl => {
            this.router.navigate([rootUrl]);
        });
    }

    isAuthenticated() {
        return this.principal.isAuthenticated();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/home.component.ts